// generated with @7nohe/openapi-react-query-codegen@1.6.2 

import { type QueryClient } from "@tanstack/react-query";
import { DefaultService } from "../requests/services.gen";
import { CandleField, CandleFilter, CandleOption, HiroStreamString, IntradayBarType, IntradayGreek, MarketActorKind, OptionAccumulationType, OptionOrigin } from "../requests/types.gen";
import * as Common from "./common";
/**
* The handler for the auth request which generates a token to validate based on basic client
* ID/secret authentication
* @param data The data for the request.
* @param data.authorization Basic Authentication
* @returns string Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetAuth = (queryClient: QueryClient, { authorization }: {
  authorization: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetAuthKeyFn({ authorization }), queryFn: () => DefaultService.getAuth({ authorization }) });
/**
* @param data The data for the request.
* @param data.sym
* @param data.stream
* @param data.field
* @param data.option
* @param data.filter
* @param data.limit
* @param data.start start timestamp in milliseconds
* @param data.end end timestamp in milliseconds
* @returns string Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetCandles = (queryClient: QueryClient, { end, field, filter, limit, option, start, stream, sym }: {
  end?: number;
  field?: CandleField;
  filter?: CandleFilter;
  limit?: number;
  option?: CandleOption;
  start?: number;
  stream?: HiroStreamString;
  sym: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetCandlesKeyFn({ end, field, filter, limit, option, start, stream, sym }), queryFn: () => DefaultService.getCandles({ end, field, filter, limit, option, start, stream, sym }) });
/**
* @param data The data for the request.
* @param data.symbol
* @param data.optionAccumulationType
* @param data.optionOrigin
* @param data.isFiltered
* @param data.candleDurationMs duration of candles. Must be a multiple of 5000
* @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
* @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
* @param data.limit max number of items to return. Default 100, max 20_000
* @returns DeltaSignalRsp Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetDeltaSignal = (queryClient: QueryClient, { candleDurationMs, isFiltered, limit, optionAccumulationType, optionOrigin, symbol, timeGte, timeLt }: {
  candleDurationMs: number;
  isFiltered: boolean;
  limit?: number;
  optionAccumulationType: OptionAccumulationType;
  optionOrigin: OptionOrigin;
  symbol: string;
  timeGte?: string;
  timeLt?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetDeltaSignalKeyFn({ candleDurationMs, isFiltered, limit, optionAccumulationType, optionOrigin, symbol, timeGte, timeLt }), queryFn: () => DefaultService.getDeltaSignal({ candleDurationMs, isFiltered, limit, optionAccumulationType, optionOrigin, symbol, timeGte, timeLt }) });
/**
* @param data The data for the request.
* @param data.symbol
* @param data.candleDurationMs duration of candles. Must be a multiple of 5000
* @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
* @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
* @param data.limit max number of items to return. Default 100, max 20_000
* @returns CandlesRsp Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetPrices = (queryClient: QueryClient, { candleDurationMs, limit, symbol, timeGte, timeLt }: {
  candleDurationMs: number;
  limit?: number;
  symbol: string;
  timeGte?: string;
  timeLt?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetPricesKeyFn({ candleDurationMs, limit, symbol, timeGte, timeLt }), queryFn: () => DefaultService.getPrices({ candleDurationMs, limit, symbol, timeGte, timeLt }) });
/**
* Fetches the list of available instruments for the day
* @returns Manifest
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetSgManifest = (queryClient: QueryClient) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetSgManifestKeyFn(), queryFn: () => DefaultService.getSgManifest() });
/**
* @param data The data for the request.
* @param data.filters
* @param data.sorting
* @param data.offset
* @param data.limit
* @returns ContractRow Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetSgTnsContracts = (queryClient: QueryClient, { filters, limit, offset, sorting }: {
  filters?: string;
  limit?: number;
  offset?: number;
  sorting?: string;
} = {}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetSgTnsContractsKeyFn({ filters, limit, offset, sorting }), queryFn: () => DefaultService.getSgTnsContracts({ filters, limit, offset, sorting }) });
/**
* The handler for the Time & Sales feed
* @param data The data for the request.
* @param data.filters
* @param data.sorting
* @param data.offset
* @param data.limit
* @returns string Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetSgTnsFeed = (queryClient: QueryClient, { filters, limit, offset, sorting }: {
  filters?: string;
  limit?: number;
  offset?: number;
  sorting?: string;
} = {}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetSgTnsFeedKeyFn({ filters, limit, offset, sorting }), queryFn: () => DefaultService.getSgTnsFeed({ filters, limit, offset, sorting }) });
/**
* The handler for the Time & Sales flow summary. Aggregate: volume, premium, delta, gamma, vega
* @param data The data for the request.
* @param data.filters
* @returns HiroAggSummary Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetSgTnsFlowSum = (queryClient: QueryClient, { filters }: {
  filters?: string;
} = {}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetSgTnsFlowSumKeyFn({ filters }), queryFn: () => DefaultService.getSgTnsFlowSum({ filters }) });
/**
* @param data The data for the request.
* @param data.start
* @param data.end
* @returns Highlights Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetSgTnsHighlights = (queryClient: QueryClient, { end, start }: {
  end?: number;
  start?: number;
} = {}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetSgTnsHighlightsKeyFn({ end, start }), queryFn: () => DefaultService.getSgTnsHighlights({ end, start }) });
/**
* The handler for the auth request which generates a token to validate based on basic client
* ID/secret authentication
* @param data The data for the request.
* @param data.authorization Bearer <jwt-token>
* @returns ServerStatus Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetStatus = (queryClient: QueryClient, { authorization }: {
  authorization: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetStatusKeyFn({ authorization }), queryFn: () => DefaultService.getStatus({ authorization }) });
/**
* The handler for the HTTP request (this gets called when the HTTP GET lands at the start
* of websocket negotiation). After this completes, the actual switching from HTTP to
* websocket protocol will occur.
* This is the last point where we can extract TCP/IP metadata such as IP address of the client
* as well as things from HTTP headers such as user-agent of the browser etc.
* @param data The data for the request.
* @param data.token
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetStream = (queryClient: QueryClient, { token }: {
  token: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetStreamKeyFn({ token }), queryFn: () => DefaultService.getStream({ token }) });
/**
* @param data The data for the request.
* @param data.symbol
* @param data.mktActor
* @param data.date
* @param data.ts
* @returns unknown Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetV2OpenInterestIntradayDelta = (queryClient: QueryClient, { date, mktActor, symbol, ts }: {
  date?: string;
  mktActor: MarketActorKind;
  symbol: string;
  ts?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetV2OpenInterestIntradayDeltaKeyFn({ date, mktActor, symbol, ts }), queryFn: () => DefaultService.getV2OpenInterestIntradayDelta({ date, mktActor, symbol, ts }) });
/**
* @param data The data for the request.
* @param data.symbol
* @param data.mktActor
* @param data.date
* @param data.ts
* @returns unknown Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetV2OpenInterestIntradayGamma = (queryClient: QueryClient, { date, mktActor, symbol, ts }: {
  date?: string;
  mktActor: MarketActorKind;
  symbol: string;
  ts?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetV2OpenInterestIntradayGammaKeyFn({ date, mktActor, symbol, ts }), queryFn: () => DefaultService.getV2OpenInterestIntradayGamma({ date, mktActor, symbol, ts }) });
/**
* @param data The data for the request.
* @param data.sym
* @param data.date
* @returns unknown Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetV2OpenInterestIntradayStats = (queryClient: QueryClient, { date, sym }: {
  date?: string;
  sym: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetV2OpenInterestIntradayStatsKeyFn({ date, sym }), queryFn: () => DefaultService.getV2OpenInterestIntradayStats({ date, sym }) });
/**
* @param data The data for the request.
* @param data.barType
* @param data.symbol
* @param data.date
* @returns unknown Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetV2OpenInterestIntradayStrikeBars = (queryClient: QueryClient, { barType, date, symbol }: {
  barType: IntradayBarType;
  date?: string;
  symbol?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetV2OpenInterestIntradayStrikeBarsKeyFn({ barType, date, symbol }), queryFn: () => DefaultService.getV2OpenInterestIntradayStrikeBars({ barType, date, symbol }) });
/**
* @param data The data for the request.
* @param data.greek
* @param data.mktActor
* @param data.symbol
* @param data.date
* @returns unknown Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetV2OpenInterestIntradayTimestamps = (queryClient: QueryClient, { date, greek, mktActor, symbol }: {
  date?: string;
  greek: IntradayGreek;
  mktActor: MarketActorKind;
  symbol?: string;
}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetV2OpenInterestIntradayTimestampsKeyFn({ date, greek, mktActor, symbol }), queryFn: () => DefaultService.getV2OpenInterestIntradayTimestamps({ date, greek, mktActor, symbol }) });
/**
* A simple handler for validating and inspecting a JWT token
* @returns Claims Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetValidateBearer = (queryClient: QueryClient) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetValidateBearerKeyFn(), queryFn: () => DefaultService.getValidateBearer() });
/**
* @param data The data for the request.
* @param data.dates
* @returns Page_VixQuote Success
* @throws ApiError
*/
export const prefetchUseDefaultServiceGetVixQuote = (queryClient: QueryClient, { dates }: {
  dates?: string[];
} = {}) => queryClient.prefetchQuery({ queryKey: Common.UseDefaultServiceGetVixQuoteKeyFn({ dates }), queryFn: () => DefaultService.getVixQuote({ dates }) });
